<script setup lang="ts">
import type { Group } from '~/models/Group'
import { computed, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { KsButton, KsCallout } from '@aschehoug/kloss'
import useGroupsStore from '~/stores/groups'
import useDialogStore from '~/stores/dialog'

const { t } = useI18n()
const { showDialog } = useDialogStore()
const groupsStore = useGroupsStore()
const { selectedGroup } = storeToRefs(groupsStore)

const calloutTitle = computed((): string => {
  return t('settings.activeGroup', { groupName: selectedGroup.value?.name })
})

const conditionalCalloutText = computed((): string => {
  if (!selectedGroup.value?.grade && (selectedGroup.value?.subjects || []).length)
    return t('settings.missingGrade')
  if (selectedGroup.value?.grade && !(selectedGroup.value?.subjects || []).length)
    return t('settings.missingSubject')
  return t('settings.changeSubjectInfo')
})

const openGroupDialog = async () => {
  selectedGroup.value = await showDialog<Group>(
    defineAsyncComponent(() => import('~/components/group/UpdateGroupMissingSubjectOrGradeDialog.vue')),
    { group: selectedGroup.value },
  )
}
</script>

<template>
  <KsCallout
    variant="info"
    :title="calloutTitle"
  >
    <p class="flex flex-col items-start gap-2">
      <span v-text="t('settings.groupInfo')" />
      <span v-text="conditionalCalloutText" />
      <KsButton
        v-if="!selectedGroup?.grade || !selectedGroup.subjects.length"
        variant="primary"
        icon-left="pencil-board"
        @click="openGroupDialog"
      >
        {{ t('groups.editGroup') }}
      </KsButton>
    </p>
  </KsCallout>
</template>
